(() => {
  const configEl = document.getElementById('service-award-config');
  if (!configEl) return;
  const config = JSON.parse(configEl.textContent);
  const STORAGE_KEY = 'fi_service_award_token';
  const LEVELS = [5, 10, 15, 20, 25, 30];
  const base = String(config.endpoint || '').replace(/\/$/, '');
  const allowed = LEVELS.includes(Number(config.requiredLevel)) ? Number(config.requiredLevel) : 0;
  const protectedPage = Boolean(config.protectedPage);
  const hide = document.getElementById('service-award-gate-style');
  const unlock = () => { if (hide) hide.remove(); };
  const clear = () => sessionStorage.removeItem(STORAGE_KEY);
  const api = async (path, body) => {
    const res = await fetch(`${base}${path}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), cache: 'no-store'
    });
    const json = await res.json();
    if (!res.ok && path === '/validate' && res.status !== 401) throw new Error(json.error || 'Please try again.');
    return json;
  };
  const codeToUrl = level => config.collections[String(level)] || '/pages/service-awards';
  async function checkAccess() {
    if (!protectedPage) { unlock(); return; }
    const token = sessionStorage.getItem(STORAGE_KEY);
    if (token && base) {
      try {
        const result = await api('/verify', { token });
        if (result.valid && Number(result.level) === allowed) { unlock(); return; }
      } catch (e) { console.warn('Award verification unavailable:', e.message); }
    }
    clear();
    // replace() avoids creating a Back-button loop for locked pages.
    window.location.replace(config.entryUrl || '/pages/service-awards');
  }
  checkAccess();
  document.querySelectorAll('[data-award-form]').forEach(form => {
    const input = form.querySelector('[data-award-code]');
    const status = form.querySelector('[data-award-status]');
    const button = form.querySelector('[type="submit"]');
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const code = input.value.trim().toUpperCase().replace(/\s+/g, '');
      if (!/^[A-Z0-9-]{1,40}SD(5|10|15|20|25|30)YR$/.test(code)) {
        status.textContent = 'Enter your employee ID followed by your award code, e.g. 111222SD5YR.';
        return;
      }
      if (!base) { status.textContent = 'Award validation has not been configured.'; return; }
      button.disabled = true;
      status.textContent = 'Checking your code…';
      try {
        const result = await api('/validate', { code });
        if (result.valid && LEVELS.includes(result.level) && result.token) {
          sessionStorage.setItem(STORAGE_KEY, result.token);
          window.location.assign(codeToUrl(result.level));
        } else {
          status.textContent = result.message || 'Invalid employee ID or award code.';
        }
      } catch (error) {
        status.textContent = 'Validation is temporarily unavailable. Please try again.';
      } finally { button.disabled = false; }
    });
  });
  document.querySelectorAll('[data-award-signout]').forEach(button => {
    button.addEventListener('click', () => { clear(); window.location.assign(config.entryUrl); });
  });
})();
